import React, { useContext, useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Headerbar from "./Headerbar";
import { UserContext } from "../../context/UserContext";
import LogoutConfirmation from "../LogoutModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { user, contextLogout, roles } = useContext(UserContext);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  // Adjust layout responsiveness based on screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      if (window.innerWidth >= 640) {
        setMobileSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    contextLogout();
    setShowLogoutModal(false);
  };

  return (
    <div className="flex h-screen bg-bodyMain">

      {/* ✅ Mobile Sidebar Toggle Button (Appears only on small screens) */}
      {(isMobile && !isMobileSidebarOpen) && (
        <button
          className="fixed top-3 left-4 z-50 p-2 bg-primary text-white rounded-md shadow-lg sm:hidden"
          onClick={() => setMobileSidebarOpen(true)}
        >
          <FontAwesomeIcon icon={faBars} size="lg" />
        </button>
      )}

      {/* ✅ Sidebar for larger screens */}
      <div className={`hidden sm:block transition-all duration-300 ${isSidebarOpen ? "w-64" : "w-16"}`}>
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          user={user}
          roles={roles}
          setShowLogoutModal={setShowLogoutModal}
        />
      </div>

      {/* ✅ Mobile Sidebar (Slide-in Drawer) */}
      {isMobileSidebarOpen && (
        <div className="fixed inset-0 backdrop-blur-sm z-40 sm:hidden" onClick={() => setMobileSidebarOpen(false)}>
          <div className="w-64 h-full" onClick={(e) => e.stopPropagation()}>
            <Sidebar
              isOpen={true}
              toggleSidebar={() => setMobileSidebarOpen(false)}
              user={user}
              roles={roles}
              setShowLogoutModal={setShowLogoutModal}
            />
          </div>
        </div>
      )}

      {/* ✅ Main Content Area */}
      <div className="pt-12 flex-grow flex flex-col overflow-hidden">

        {/* ✅ Header */}
        <Headerbar
          user={user}
          roles={roles}
          setShowLogoutModal={setShowLogoutModal}
          isSidebarOpen={isSidebarOpen}
        />

        {/* ✅ Page Content (Responsive Spacing) */}
        <div className="flex-grow py-16 sm:p-6 h-full overflow-y-auto">
          {/* Glow Effects Layer - Added pointer-events-none */}
          <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden blur-[20px]">
            <div className="absolute w-[250px] h-[250px] bg-[#f15bb53a] opacity-55 rounded-[60px] 
       -top-[15%] left-[5%] rotate-45" />

            <div className="absolute w-[230px] h-[230px] bg-[#9a5de52a] opacity-55 rounded-full 
       top-[10%] right-[15%]" />

            <div className="absolute w-[320px] h-[320px] bg-[#ffc53d23] opacity-55 
     bottom-[5%] left-[8%] transform"
              style={{
                clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
                transform: 'rotate(15deg)',
                borderRadius: '50px'
              }}
            />


            <div
              className="absolute w-[420px] h-[420px] bg-[#00bb7d28] opacity-45 
             -bottom-[15%] -right-[3%] transform"
              style={{
                clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
                transform: 'rotate(-45deg)'
              }}
            />


          </div>

          {/* Content Layer - Added positive z-index */}
          <div className="relative z-10">
            {children}
          </div>
        </div>

        {/* ✅ Footer (Adapts to screen size) */}
        {/* <Footer isSidebarOpen={isSidebarOpen} /> */}
      </div>

      {/* ✅ Logout Confirmation Modal */}
      <LogoutConfirmation
        isOpen={showLogoutModal}
        onConfirm={handleLogout}
        onClose={() => setShowLogoutModal(false)}
      />
    </div>
  );
};

export default Layout;
